import * as React from 'react';

/**
 * @description Medal icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Medal } from '@sravni/design-system-icons'
 *
 * <Medal />
 * ```
 */
const Medal = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Medal", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M10 18.333V17.5M4.742 16.925l.516-.517M16.25 11.667h.833M2.917 11.667h.833M14.742 16.408l.516.517M12.456 9.211a3.472 3.472 0 1 1-4.911 4.911 3.472 3.472 0 0 1 4.91-4.91ZM13.692 5H6.308", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m13.063 10.065 3.18-3.565c.273-.305.424-.7.424-1.11V3.334c0-.916-.75-1.666-1.667-1.666H5c-.92 0-1.667.746-1.667 1.666v2.058c0 .409.151.804.424 1.109l3.18 3.565M3.808 2.192l5.425 6.091M16.192 2.192l-5.425 6.091", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { Medal };
//# sourceMappingURL=Medal.js.map
